import { getErrorStatus } from "./retryPolicy.ts";

/**
 * The step-up refusal, as both apps see it: `403` with `code: "OTP_REQUIRED"`.
 * An account whose number was proven only by a claim link or a roster gets it
 * from the actions that change what the account is (connect a login provider
 * or inbox, add an account, change the number, delete) until the person proves
 * the number by code.
 */
export const isOtpRequired = (error: unknown): boolean => isRefusal(error, "OTP_REQUIRED");

/**
 * Whether a request was refused `403` with this `code`. `PHONE_VERIFICATION_REQUIRED`
 * is what an account an emailed claim link signed in to gets for anything but
 * proving a phone.
 */
export const isRefusal = (error: unknown, code: string): boolean => {
  if (getErrorStatus(error) !== 403) return false;
  const response = readProperty(error, "response");
  const data = readProperty(response, "data");
  return readProperty(data, "code") === code;
};

/** One key off an unknown value, or undefined; no assertion anywhere. */
const readProperty = (value: unknown, key: string): unknown => {
  if (typeof value !== "object" || value === null || !(key in value)) return undefined;
  const record: Record<string, unknown> = { ...value };
  return record[key];
};

/** Whether this account's ownership-changing actions will be refused until a code. */
export const needsStepUp = (phoneVerifiedBy: string | null | undefined): boolean =>
  phoneVerifiedBy === "roster" || phoneVerifiedBy === "claimLink";
